import React from "react";
import { useTranslation } from "@/context/LanguageContext";

const LOGOS = ["Tata Power", "Adani Solar", "Waaree", "Luminous", "Vikram", "Havells"];

export default function TrustSection() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="trust-section"
      className="py-12 bg-white border-t border-stone-100"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center text-xs uppercase tracking-[0.25em] text-stone-500">
          {t("trust.heading")}
        </div>
        <div className="mt-6 grid grid-cols-3 md:grid-cols-6 gap-6 items-center">
          {LOGOS.map((l) => (
            <div
              key={l}
              className="text-center font-display font-bold text-stone-400 hover:text-green-700 transition text-lg"
            >
              {l}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
